module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"svg":{"alia-label":{"like":"いいねのアイコン","bookmark":"ブックマークのアイコン"},"title":{"like":"いいね","bookmark":"ブックマーク"},"desc":{"like":"いいねのアイコン","bookmark":"ブックマークのアイコン"}}}}')
  delete Component.options._Ctor
}
